import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { LoginModel } from 'app/pages/content-pages/login/login-page.component';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from 'environments/environment';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { AccessibleClientModel, UnreadNotificationModel } from 'app/dashboard/home/home.component';

@Injectable()
export class AuthService {

  constructor(
    public router: Router,
    private _client: HttpClient) { }

  signinUser(model: LoginModel) {
    return this._client.post(`${environment.apiUrl}users/auth`,model, { withCredentials: true });
  }

  logout() {
    localStorage.removeItem('id-t');
    this.router.navigate(['/pages/login']);
  }

  isAuthenticated(): boolean {
    return !new JwtHelperService().isTokenExpired(localStorage.getItem('id-t')) ? true : false;
  }

  static GetCurrentUser(): UserInfo {
    let token = localStorage.getItem('id-t');
    let userInfo = new JwtHelperService().decodeToken<UserInfo>(token);
    return userInfo;
  }

  getAccessibleClientList(platform:string): Observable<Array<AccessibleClientModel>> {
    return this._client.get<Array<AccessibleClientModel>>(`${environment.apiUrl}clients/getAccessibleClientList?platform=${platform}`);
  }

  generateClientToken(appType: string, clientId: string) {
    return this._client.get(`${environment.apiUrl}home/auth/client?appType=${appType}&clientId=${clientId}`);
  }

  getUnreadNotificationCount(appType: string): Observable<UnreadNotificationModel> {
    return this._client.post<UnreadNotificationModel>(`${environment.notificationApiUrl}get-unread-count`, { appType: appType });
  }
  

  

 // auth.service.ts mein is method ko replace karo
// auth.service.ts mein isko replace kar do
getRequestedUserList(requestTypeId: number, pageNum: number, pageSize: number, 
                     uName?: string, mName?: string, ip?: string, 
                     deviceUID?: string, pcType?: string, region?: string) { // NAYA
  
  let url = `${environment.apiUrl}authenticateUser/getRequestedUserList?requestTypeId=${requestTypeId}&pageNumber=${pageNum}&pageSize=${pageSize}`;

  if (uName) url += `&userName=${encodeURIComponent(uName)}`;
  if (mName) url += `&machineName=${encodeURIComponent(mName)}`;
  if (ip) url += `&ipAddress=${encodeURIComponent(ip)}`;
  if (deviceUID) url += `&deviceUID=${encodeURIComponent(deviceUID)}`; // NAYA
  if (pcType) url += `&pcType=${encodeURIComponent(pcType)}`;          // NAYA
  if (region) url += `&region=${encodeURIComponent(region)}`;          // NAYA

  return this._client.get<any>(url);
}
  authenticateUserbyId(requestId: number, statusId: number){
    return this._client.post
    (`${environment.apiUrl}authenticateUser/authenticateUser?requestId=${requestId}&statusId=${statusId}`,null);
  }
}

export class UserInfo {
  id: string;
  firstName: string;
  lastName: string;
  name: string;
  loginId: string;
  roleIds: string;
}

